import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
const NO_RISK = ['Sin formularios complicados.', 'Sin explicaciones.', 'Sin riesgos.'];
export function Guarantee() {
  return <section className="w-full bg-cream-50 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-95" data-mp="222d797tvk6hi">
      <div className="mx-auto w-full max-w-xl px-4" data-id="element-96" data-mp="1x5d69bbvttx9">
        <div className="rounded-3xl border-2 border-gold-500/40 bg-white p-5 text-center shadow-[0_18px_45px_-32px_rgba(11,32,56,0.6)] sm:p-7" data-id="element-97" data-mp="19eqvvdeenxk3">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-navy-900" data-id="element-98" data-mp="14gpcssgzby8m">
            <ShieldCheckIcon className="h-8 w-8 text-gold-400" aria-hidden="true" data-id="element-99" data-mp="1j5c4zurpgkh9" />
          </span>
          <h2 id="guarantee-title" className="mt-4 font-display text-[24px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-100" data-mp="1ed279skcmg4f">
            Garantía incondicional de 7 días
          </h2>
          <p className="mt-3 text-[14.5px] leading-relaxed text-navy-800/80 sm:text-base" data-id="element-101" data-mp="lownb814cv5n">
            Pruebe el Sistema Maestro de TRT™. Revise los tomos, utilice los protocolos,
            analice los algoritmos. Si considera que no le aporta más claridad y seguridad
            para tomar decisiones clínicas, envíenos un correo dentro de los primeros 7 días y
            le devolvemos el 100% de su dinero.
          </p>
          <ul className="mt-4 flex flex-col items-center gap-1.5" data-id="element-102" data-mp="60nl7jr69ggl">
            {NO_RISK.map(item => <li key={item} className="text-[13px] font-bold uppercase tracking-[0.08em] text-gold-700" data-id="element-103" data-mp="azgwd5izkvdl">
                {item}
              </li>)}
          </ul>
        </div>

        <SectionCta label="Quiero probarlo sin ningún riesgo" data-id="element-104" data-mp="k1838dp9j891" />
      </div>
    </section>;
}